import { z } from 'zod';
/** Журнал отправок писем — view-only для админа. */
export const notificationLogItemSchema = z.object({
    id: z.string(),
    channel: z.string(),
    /** EMAIL: получатель из meta.to; IN_APP: email пользователя если есть. */
    recipient: z.string().nullable(),
    subject: z.string(),
    /** QUEUED | SENT | FAILED | READ. */
    status: z.string(),
    /** Текст ошибки если status=FAILED. */
    error: z.string().nullable(),
    /** Что это за уведомление (verify-email, password-reset, resend-verify-email, test, ...). */
    kind: z.string().nullable(),
    createdAt: z.string().datetime(),
    sentAt: z.string().datetime().nullable(),
});
export const notificationLogQuerySchema = z.object({
    status: z.enum(['QUEUED', 'SENT', 'FAILED', 'READ']).optional(),
    /** Поиск по recipient, subject. */
    search: z.string().max(200).optional(),
    /** Лимит, по умолчанию 100, максимум 500. */
    limit: z
        .union([z.number(), z.string()])
        .optional()
        .transform((v) => {
        const n = typeof v === 'string' ? parseInt(v, 10) : v;
        if (!n || Number.isNaN(n))
            return 100;
        return Math.min(Math.max(n, 1), 500);
    })
        .pipe(z.number()),
});
//# sourceMappingURL=notifications.js.map